const MouseIcon = () => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6.75H6.41667V0H5.83333C2.61042 0 0 2.51719 0 5.625V6.75ZM0 7.875V12.375C0 15.4828 2.61042 18 5.83333 18H8.16667C11.3896 18 14 15.4828 14 12.375V7.875H7H0ZM14 6.75V5.625C14 2.51719 11.3896 0 8.16667 0H7.58333V6.75H14Z"
      fill="black"
    />
  </svg>
);

export default MouseIcon;
